module.exports = __webpack_public_path__ + "img/second_fire_operation.c3b640db.png";